import React from 'react';
import PropTypes from 'prop-types';
import { Flex, Box, Icon } from 'roo-ui/components';
import styled from '@emotion/styled';
import { themeGet } from 'styled-system';
import Image from 'components/Image';
import pluralize from 'pluralize';

const SemiTransparentPill = styled(Box)`
  position: absolute;
  background: rgba(34, 34, 34, 0.5);
  border-radius: ${themeGet('radii.default')};
  padding: 0 ${themeGet('space.2')};
  color: white;
  font-weight: bold;
  left: ${themeGet('space.2')};
  bottom: ${themeGet('space.2')};
`;

const ImageGalleryThumbnail = ({ src, alt, imageCount, counterSize, lazy, ...rest }) => {
  const imagesString = counterSize === 'small' ? imageCount : pluralize('image', imageCount, true);
  const iconSize = counterSize === 'small' ? 16 : 24;

  return (
    <Box position="relative">
      <Image src={src} alt={alt} lazy={lazy} {...rest} />
      <SemiTransparentPill>
        <Flex alignItems="center">
          <Icon name="photo" size={iconSize} color="white" mr={1} />
          <Box>{imagesString}</Box>
        </Flex>
      </SemiTransparentPill>
    </Box>
  );
};

ImageGalleryThumbnail.propTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
  imageCount: PropTypes.number.isRequired,
  counterSize: PropTypes.oneOf(['large', 'small']),
  lazy: PropTypes.bool,
};

ImageGalleryThumbnail.defaultProps = {
  counterSize: 'small',
  lazy: false,
};

export default ImageGalleryThumbnail;
